import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { FAQ_OVERVIEW_URL } from '#client/constants/FAQs';

import { LinkStyled } from './BankingFAQs.style';

export default function BankingFAQs({ to, appPageName = 'active_banking_dashboard' }) {
  const linkPressedTracker = useLinkPressedCallback({
    elementName: 'Banking_FAQ_link',
    elementText: 'Banking FAQs',
    elementAsset: '/s2/icon/arrow-sm-right-fill.svg',
    appPageName
  });

  const handleClick = () => linkPressedTracker();

  return (
    <LinkStyled
      onClick={handleClick}
      target="_blank"
      to={to ?? FAQ_OVERVIEW_URL}
    >
      <Stack
        alignItems="center"
        direction="row"
        gap="8px"
      >
        <Text
          color="primary"
          size="sm"
          weight="medium"
        >
          Banking FAQs
        </Text>
        <SharedAsset
          alt=""
          height={12}
          src="/s2/icon/arrow-sm-right-fill.svg"
          width={12}
        />
      </Stack>
    </LinkStyled>
  );
}

BankingFAQs.propTypes = {
  to: PropTypes.string,
  appPageName: PropTypes.string
};
